import { useLocation } from "react-router-dom";

export type Lang = "fr";

type Dict = Record<string, string>;

const fr: Dict = {
  // Header
  "header.discuter": "Discuter",
  "header.discuter_aria": "Discuter avec Eugénie",
  "header.prendre_rdv": "Prendre rdv",
  "header.prendre_rdv_aria": "Prendre rendez-vous avec Eugénie",
  "header.demande_short": "Demande",
  "header.envoyer_demande": "Envoyer ma demande",
  "header.plateforme_short": "Plateforme",
  "header.plateforme_full": "Accéder à la plateforme Naos",
  "header.pill_role": ", votre conseillère ",
  "header.pill_role_suffix": "",

  // Helmet
  "seo.title": "Naboo × Naos — Plateforme événementielle dédiée aux collaborateurs Naos",
  "seo.description": "Plateforme Naboo réservée exclusivement aux collaborateurs Naos : organisez vos séminaires, événements et team building avec des conditions négociées et un accompagnement dédié par Eugénie.",
  "seo.og.description": "Espace privé Naos × Naboo : organisez vos séminaires et événements d'entreprise avec tarifs négociés et accompagnement dédié. Réservé aux équipes Naos.",
  "seo.og.image_alt": "Logos Naos et Naboo — Votre plateforme événementielle dédiée",
  "seo.twitter.title": "Naboo × Naos — Plateforme événementielle dédiée",
  "seo.twitter.description": "Espace privé Naos × Naboo : séminaires, événements et team building avec tarifs négociés et conseillère dédiée.",
  "seo.twitter.image_alt": "Naboo × Naos — Plateforme événementielle dédiée",
  "seo.author": "Naboo pour Naos",
  "seo.locale": "fr_FR",
  "html.lang": "fr",

  // Hero
  "hero.badge": "Quiz",
  "hero.title": "Quelques questions rapides pour trouver votre lieu idéal.",
  "hero.step.type": "Type d'événement",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Votre match",
  "hero.cta": "Démarrer →",
  "hero.subline": "Résultats en moins de 30 sec",

  // Stats
  "stats.partnership_value": "2025",
  "stats.partnership": "Partenaire depuis",
  "stats.events": "Événements",
  "stats.participants": "Participants",
  "stats.colleagues": "Collègues inscrits",
  "stats.fees_value": "0€",
  "stats.fees": "Frais de service",

  // Colleagues
  "colleagues.title": "Déjà 43 collègues Naos sont inscrits sur Naboo",
  "colleagues.paragraph": "Retrouvez l'historique de vos événements, le suivi de vos projets en cours et tous vos devis au même endroit.",
  "colleagues.cta": "Créer un compte →",
  "colleagues.label": "Vos collègues utilisent déjà Naboo",
  "colleagues.more": "collègues",

  // Top destinations
  "destinations.title": "Top destinations",
  "destinations.instant": "Réservation instantanée",
  "destinations.bottom_title": "Découvrez plus de 50 000 lieux et prestataires dans notre base de données",
  "destinations.bottom_subtitle": "Explorez l'ensemble du catalogue Naboo réservé aux équipes Naos.",
  "destinations.bottom_cta": "Explorer les lieux →",

  // Push
  "push.line1": "Votre lieu idéal en 30 sec",
  "push.line2": "Quiz Naboo",
  "push.close": "Fermer",

  // Events
  "events.title": "Organisez tout type d'événement, de 5 à 500 participants, partout dans le monde",
  "events.prev": "Précédent",
  "events.next": "Suivant",
  "events.go_to": "Aller à l'événement",
  "events.stay": "Séjour avec nuitée",
  "events.conf": "Conférences",
  "events.rooms": "Réservation de chambres pour expositions et salons",
  "events.awayday": "Journée externe | Réunion | Session de formation",
  "events.parties": "Soirées d'entreprise | Afterworks",
  "events.meals": "Repas d'affaires | Traiteur",
  "events.tb": "Activité team building",

  // Services
  "services.title": "Une seule plateforme pour toute votre logistique",
  "services.paragraph": "De la salle de réunion au bus de transfert, on s'occupe de tout. Vous n'avez qu'un seul interlocuteur : Eugénie.",
  "services.catering": "Restauration & traiteurs",
  "services.animation": "Animation & speakers",
  "services.transport": "Transport & transferts",
  "services.hotels": "Hôtels & lieux",
  "services.coworking": "Salles & coworking",
  "services.more": "+ tout autre service événementiel sur demande",

  // Preferred terms
  "pt.title": "Bénéficiez de conditions préférentielles",
  "pt.col.invoicing": "Portage de factures",
  "pt.col.standard": "Service Standard",
  "pt.col.turnkey": "Service Clé en Main",
  "pt.group.admin": "Admin",
  "pt.group.search": "Recherche de lieu",
  "pt.group.management": "Gestion d'événement",
  "pt.row.fees": "Frais",
  "pt.row.advance": "Avance d'acompte",
  "pt.row.referencing": "Référencement de nouveaux lieux et prestataires via Naboo",
  "pt.row.autonomy": "Autonomie complète sur la plateforme",
  "pt.row.delegation": "Délégation du brief à un expert événementiel avec suggestions et support illimités",
  "pt.row.assistance": "Assistance illimitée pour négocier les prix et conditions",
  "pt.row.app": "Application événementielle pour organisateurs et participants",
  "pt.row.visit": "Visite du site",
  "pt.row.coordination": "Coordination des prestataires après signature du devis",
  "pt.row.onsite": "Gestionnaire d'événement sur place pendant l'événement (>40K€)",
  "pt.discover_fees": "Découvrez nos frais",
  "pt.cta": "Découvrir la plateforme Naos",

  // How to
  "how.badge": "En 6 étapes simples",
  "how.title": "Comment faire ?",
  "how.step": "Étape",
  "how.of": "/",
  "how.prev": "Étape précédente",
  "how.next": "Étape suivante",
  "how.go_to": "Aller à l'étape",
  "how.s1.title": "Envoyez votre brief",
  "how.s1.desc": "Envoyez votre brief à votre expert événementiel (via la plateforme, par email ou par téléphone) ou recherchez en utilisant la barre de recherche en toute autonomie.",
  "how.s1.link.platform": "Lien vers la plateforme",
  "how.s2.title": "Obtenez une réponse rapide",
  "how.s2.desc": "Votre expert événementiel répond dans l'heure, fait les premières suggestions dans les 2 heures et finalise vos devis dans les 2 jours.",
  "how.s3.title": "Demandez des ajustements",
  "how.s3.desc": "Demandez des ajustements ou de nouvelles propositions. Votre expert met tout à jour dans les 24 heures jusqu'à ce que vous soyez prêt à confirmer votre réservation. Les ajustements sont illimités.",
  "how.s4.title": "Confirmez la réservation",
  "how.s4.desc": "Quand vous êtes satisfait de vos devis, téléchargez le devis qui correspond à vos attentes et lancez votre processus de demande d'achat.",
  "how.s5.title": "Créez votre demande d'achat",
  "how.s5.desc": "Pendant la validation de votre demande d'achat, cliquez sur 'Confirmer la réservation' sur la plateforme pour télécharger la facture finale et transformer votre demande d'achat en bon de commande. Naboo s'occupe de tout.",
  "how.s6.title": "Obtenez un support complet (optionnel)",
  "how.s6.desc": "Si vous avez besoin d'aide pour organiser votre événement, Naboo peut vous fournir un support complet de gestionnaire d'événement jusqu'au jour de l'événement, il suffit de demander !",

  // Footer
  "footer.terms": "Conditions générales d'utilisation",
  "footer.cgu": "CGU",
  "footer.contact": "Contactez-nous",
  "footer.cookies": "Modifier vos préférences de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  // Popover
  "pop.subject": "Demande Naos",
  "pop.copy": "Copier l'email",
  "pop.gmail": "Ouvrir dans Gmail",
  "pop.outlook": "Ouvrir dans Outlook",
  "pop.mail_app": "Utiliser mon application mail",
  "pop.copied": "Email copié",
  "pop.copy_error": "Impossible de copier",

  // Lang
  "lang.fr": "FR",

  // Quiz
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Catégories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.title.type": "Quel type d'événement organisez-vous ?",
  "quiz.title.categories": "Quelle ambiance recherchez-vous ?",
  "quiz.title.participants": "Combien de participants ?",
  "quiz.title.standing": "Quel est votre budget ?",
  "quiz.title.dates_prefix": "Quand a lieu votre ",
  "quiz.title.dates_suffix": " ?",
  "quiz.title.event_word": "événement",
  "quiz.label.0": "Type d'événement",
  "quiz.label.1": "Dates",
  "quiz.label.2": "Catégories",
  "quiz.label.3": "Participants",
  "quiz.label.4": "Budget",
  "quiz.label.5": "Vos coordonnées",
  "quiz.month.0": "Janvier",
  "quiz.month.1": "Février",
  "quiz.month.2": "Mars",
  "quiz.month.3": "Avril",
  "quiz.month.4": "Mai",
  "quiz.month.5": "Juin",
  "quiz.month.6": "Juillet",
  "quiz.month.7": "Août",
  "quiz.month.8": "Septembre",
  "quiz.month.9": "Octobre",
  "quiz.month.10": "Novembre",
  "quiz.month.11": "Décembre",
  "quiz.evt.seminaire": "Séminaire d'entreprise",
  "quiz.evt.journee_hors_site": "Journée hors site",
  "quiz.evt.soiree": "Soirée d'entreprise",
  "quiz.evt.team_building": "Activité team building",
  "quiz.evt.conference": "Conférence",
  "quiz.evt.lancement_produit": "Lancement de produit",
  "quiz.evt.autre": "Autre",
  "quiz.evt.placeholder": "Précisez le type d'événement",
  "quiz.cat.Plage": "Plage",
  "quiz.cat.Montagne": "Montagne",
  "quiz.cat.Ville": "Ville",
  "quiz.cat.Nature": "Nature",
  "quiz.cat.Désert": "Désert",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Bord de lac",
  "quiz.cat.Île": "Île",
  "quiz.cat.Historique": "Historique",
  "quiz.cat.Luxe": "Luxe",
  "quiz.cat.Aventure": "Aventure",
  "quiz.cat.Bien-être": "Bien-être",
  "quiz.dates.placeholder": "Choisir une date",
  "quiz.dates.or_month": "Ou choisissez un mois",
  "quiz.participants.hint": "Nombre de participants",
  "quiz.participants.placeholder": "Ex : 25",
  "quiz.budget.per_person": "soit {p} € par personne",
  "quiz.budget.or": "OU",
  "quiz.budget.placeholder": "Budget total exact",
  "quiz.budget.exact": "Saisir un montant exact",
  "quiz.standing.Essentiel": "Essentiel",
  "quiz.standing.Confort": "Confort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestige",
  "quiz.standing.Exception": "Exception",
  "quiz.match.title": "Recevez vos suggestions",
  "quiz.match.subtitle": "Indiquez votre email professionnel pour recevoir votre sélection personnalisée.",
  "quiz.match.email_placeholder": "votre.email@naos.com",
  "quiz.match.cta": "Recevoir mes suggestions",
  "quiz.match.sending": "Envoi en cours…",
  "quiz.match_suffix": "% de match",
  "quiz.email.required": "Email requis",
  "quiz.email.invalid": "Email invalide",
  "quiz.email.pro": "Merci d'utiliser votre email professionnel",
  "quiz.success.title": "Demande envoyée !",
  "quiz.success.subtitle": "Eugénie revient vers vous très rapidement avec une sélection personnalisée.",
  "quiz.success.close": "Fermer",
  "quiz.engagement.title": "Comment souhaitez-vous recevoir vos suggestions ?",
  "quiz.engagement.subtitle": "Plus qu'une étape",
  "quiz.engagement.email_title": "Par email",
  "quiz.engagement.email_desc": "Directement dans votre boîte mail sous 2 heures.",
  "quiz.engagement.email_b1": "Recevez un récapitulatif de votre brief",
  "quiz.engagement.email_b2": "Obtenez des recommandations sur-mesure",
  "quiz.engagement.email_b3": "Réservez votre événement en toute autonomie",
  "quiz.engagement.email_cta": "Recevoir par email",
  "quiz.engagement.rdv_title": "Lors d'un échange avec Eugénie",
  "quiz.engagement.rdv_desc": "Uniquement de vraies recommandations.",
  "quiz.engagement.rdv_b1": "Sans engagement",
  "quiz.engagement.rdv_b2": "Un vrai humain, pas un bot",
  "quiz.engagement.rdv_b3": "100 % adapté à vos besoins",
  "quiz.engagement.rdv_cta": "Réserver un créneau",
  "quiz.engagement.rdv_modal_title": "Réserver un créneau avec Eugénie",
  "quiz.engagement.rdv_success_title": "Rendez-vous confirmé !",
  "quiz.engagement.rdv_success_subtitle": "Eugénie vous contactera au créneau choisi. Une invitation est dans votre boîte mail.",
  "quiz.nav.back": "Retour",
  "quiz.nav.next": "Suivant",
  "quiz.aria.close": "Fermer",
  "quiz.tier.Petit comité": "Petit comité",
  "quiz.tier.Groupe convivial": "Groupe convivial",
  "quiz.tier.Grande équipe": "Grande équipe",
  "quiz.tier.Grand événement": "Grand événement",
  "quiz.tier.Événement XL": "Événement XL",

  // AI Planner
  "ai_planner.pill": "Nouveau · IA",
  "ai_planner.title": "Construisons votre prochain événement",
  "ai_planner.description": "Décrivez votre événement et notre IA vous suggérera des options personnalisées.",
  "ai_planner.cta": "Essayer l'IA planner",
};

const dicts: Record<Lang, Dict> = { fr };

export function detectLang(_pathname: string): Lang {
  return "fr";
}

export function useArkemaLang() {
  const { search } = useLocation();
  const lang: Lang = "fr";
  const t = (key: string): string => dicts[lang][key] ?? key;
  const switchPath = (_target: Lang): string => `/${search || ""}`;
  return { lang, t, switchPath };
}

export function getT(lang: Lang) {
  return (key: string): string => dicts[lang][key] ?? key;
}
